import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import Link from "@insite/mobius/Link";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import TextAutoSlider from "@NA/Components/ADITextSlider";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import toggleRewardsDrawer from "@NA/Handlers/ADIRewardsDrawerHandler";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import convertHtmlToObjectValues from "@NA/Utils/Utility";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";
import ADITrackOrder from "@NA/Widgets/ADITrackOrder";
import { useHistory } from "@NA/Hooks/useHistory";

const enum fields {
    backgroundColor = "backgroundColor",
    topBannerTextFeild = "topBannerTextFeild",
    color = "color",
    interval = "interval",
    links = "links",
}

export interface LinksIdArray {
    title: string;
    redirectUrl: string;
    openInNewWindow: boolean;
    authentication: string;
    hideInDesktop: boolean;
}

export interface LinksIdModel {
    fields: LinksIdArray;
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
        [fields.topBannerTextFeild]: string;
        [fields.color]: string;
        [fields.interval]: number;
        [fields.links]: LinksIdModel[];
    };
}

const mapStateToProps = (state: CustomApplicationState) => ({
    enableWarehousePickup: getSettingsCollection(state).accountSettings.enableWarehousePickup,
    session: state.context.session,
    toggleDrawer: state.ADIGlobalData.loginDrawerStore.loginDrawer,
});

const mapDispatchToProps = {
    toggleLoginDrawer,
    toggleRewardsDrawer
};
type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const Navigation = styled.div<{ $background?: string; }>`
    color: ${getColor("primary.contrast")};
    font-size: 14px;
    min-height: 35.889px;
    background-color: ${props => (props.$background !== "" ? props.$background : "#2380A3")};
    display: flex;
    justify-content: flex-end;
    align-items: center;
    ${({ theme }: { theme: BaseTheme; }) =>
        breakpointMediaQueries(theme, [
            css`
                min-height: 25px;
            `,
            css`
                min-height: 25px;
            `,
            css`
                min-height: 25px;
            `,
            null,
            null,
        ])}
`;

const NavItem = styled.span<InjectableCss>`
    display: inline-flex;

    > span,
    > a {
        margin-left: 10px;
    }
    ${injectCss}
`;

export interface HeaderLinkListStyles {
    wrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    leftSide?: InjectableCss;
    rightSide?: InjectableCss;
    trackOrderLink?: InjectableCss;
}

export const headerLinkListStyles: HeaderLinkListStyles = {
    wrapper: {
        css: css`
            width: 1470px;
            margin: 0 auto;
            height: 100%;
            ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    innerWrapper: {
        css: css`
            display: flex;
            width: 100%;
            height: 100%;
        `,
    },
    leftSide: {
        css: css`
            width: auto;
            flex: 1;
            ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        margin-left: 0px !important;
                    `,
                    css`
                        width: 100%;
                        margin-left: 0px !important;
                    `,
                    css`
                        width: 65%;
                        margin-left: 0px !important;
                    `,
                    css`
                        width: 75%;
                    `,
                    null,
                ])}
            > div[class^="Wrapper"] {
                ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                            margin-left: 263px;
                        `,
                ])}
                div[class^="ContentWrapper"] {
                    height: 100%;
                    padding: 8px 0 8px;
                    background: transparent;
                    text-align: center;
                    color: #fff;
                    clear: both;
                    max-height: 100%;
                    overflow: hidden;
                    height: auto;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: normal;
                }
                strong {
                    font-size: 14px;
                    padding: 0 15px;
                    margin: 0 auto;
                    color: ${getColor("primary.contrast")} !important;
                    height: 100%;
                    font-weight: 600;
                    ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                                text-align: center;
                            `,
                ])}
                    span {
                        text-decoration: underline;
                        color: ${getColor("primary.contrast")} !important;
                    }
                }
            }
        `,
    },
    rightSide: {
        css: css`
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: auto;
            ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        width: 35%;
                    `,
                    css`
                        width: 25%;
                    `,
                    null,
                ])}
        `,
},
    trackOrderLink: {
    css: css`
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: auto;
        ${StyledButton} {
            margin-top: 0px;
            margin-right: 15px;
            ${TypographyStyle} {
                color: #ffffff;
                font-size: 12px;
                font-weight: 600;
                line-height: normal;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        ${TypographyStyle} {
            color: #ffffff;
            font-size: 14px;
            font-weight: 600;
            line-height: normal;
            &:hover {
                text-decoration: underline;
            }
        }
        ${({ theme }: { theme: BaseTheme; }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    width: 35%;
                `,
                css`
                    width: 25%;
                `,
                null,
            ])}
    `,
},
};   
        
export const HeaderLinkList: React.FC<Props> = ({
    id,
    session,
    toggleDrawer,
    toggleLoginDrawer,
    toggleRewardsDrawer,
    fields: { backgroundColor, topBannerTextFeild, color, interval, links },
}) => {
    const styles = useMergeStyles("headerLinkList", headerLinkListStyles);
    const topBannerSliderData = convertHtmlToObjectValues(topBannerTextFeild);
    const isAuthenticated = (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const linksVal = links.map(fields => fields.fields);
    const setMarginLeft = () => {
        const rightSection = document.querySelector<HTMLElement>(".right-section");
        const leftSection = document.querySelector<HTMLElement>(".left-section");
        if (rightSection && leftSection) {
            const topLinksWidth = rightSection.offsetWidth;
            leftSection.style.marginLeft = `${topLinksWidth}px`;
        }
    };
    const history = useHistory(); 

    const closeSignInPopUp = (url: any) => {
        history.push(url);
        if (toggleDrawer) {toggleLoginDrawer({ loginDrawer: false });}
        toggleRewardsDrawer({ rewardsDrawer: false });
    };
    useEffect(() => {
        setMarginLeft();
        window.addEventListener("resize", setMarginLeft);
    }, []);

    const defaultLinks = linksVal.filter(link => link.authentication === "Default");
    const conditionalLinks = linksVal.filter(
        link => link.authentication !== "Default" && link.authentication !== undefined,
    );

    const rightSideLinkCustomStyles = () => css`
            > ${StyledButton} {
                padding: 0;
                display: flex;
                align-items: center;
                margin-left: 0px;
                margin-right: 15px;
                &:focus {
                    ${({ theme }) => {
            return breakpointMediaQueries(
                theme, [null, null, null,
                css` 
                                outline-color: ${ADIColors.white};       
                                outline-style: ${getProp("theme.focus.style", "solid")};
                                outline-width: 0px;
                                `,],
                "min",);
        }}                  
                }
                &:focus-visible {
                    ${({ theme }) => {
            return breakpointMediaQueries(
                theme, [null, null, null,
                css` 
                            outline-color: ${ADIColors.white};       
                            outline-style: ${getProp("theme.focus.style", "solid")};
                            outline-width: 1px;
                            outline-offset: 1px; `,],
                "min",);
        }}
                } 
                
                > ${TypographyStyle} {
                    font-size: 12px;
                    font-weight: 600;
                    display: inline-block;
                    color: ${color};
                    white-space: nowrap;
                    &:hover {
                        color: ${color};
                        text-decoration: underline;
                    }                    
                }
            }
        `;

    const renderLink = (link: LinksIdArray, key: string) => {
        const target = link.openInNewWindow ? "_blank" : "_self";
        if (link.hideInDesktop) {
            return null;
        }
        const isLinkAuthed = link.authentication === "Authenticated";
        const isLinkUnAuthed = link.authentication === "Unauthenticated";
        if (isLinkAuthed && !isAuthenticated) {
            return null;
        }
        if (isLinkUnAuthed && isAuthenticated) {
            return null;
        }

        return (
            <>
            <Link
                key={`${link.redirectUrl}.${link.title}-${key}`}
                href={link.redirectUrl}
                target={target}
                onClick={() => closeSignInPopUp(link.redirectUrl)}
            >
                {link.title}
            </Link>           
            </>
        );

    };

    return (
        <>
        <Navigation $background={backgroundColor}>
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.innerWrapper}>
                    <NavItem {...styles.leftSide} className="left-section">
                        <TextAutoSlider textList={topBannerSliderData} color={color} interval={interval} toggleLoginDrawer={toggleLoginDrawer} toggleRewardsDrawer={toggleRewardsDrawer}/>
                    </NavItem>
                    <Hidden below="md" {...styles.rightSide} className="right-section">
                    <StyledWrapper {...styles.trackOrderLink}>
                    </StyledWrapper>
                        <NavItem css={rightSideLinkCustomStyles()}>
                            {conditionalLinks.map((link, i) => link.redirectUrl && renderLink(link, `conditional${i}`))}
                            {defaultLinks.map((link, i) => link.redirectUrl && renderLink(link, `default${i}`))}
                        </NavItem>
                    </Hidden>
                </StyledWrapper>
            </StyledWrapper>
        </Navigation>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(HeaderLinkList),
    definition: {
        group: "Header",
        icon: "LinkList",
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "title",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "redirectUrl",
                        displayName: "Redirect Url",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isRequired: true,
                    },
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: "authentication",
                        displayName: "Authentication",
                        editorTemplate: "DropDownField",
                        options: [
                            { displayName: "Default", value: "Default" },
                            { displayName: "Authenticated", value: "Authenticated" },
                            { displayName: "Unauthenticated", value: "Unauthenticated" },
                        ],
                        defaultValue: "Default",
                        isRequired: true,
                    },
                    {
                        name: "hideInDesktop",
                        displayName: "Hide in Desktop",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                ],
            },
            {
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Background Color",
                defaultValue: "#2380A3",
                fieldType: "General",
            },
            {
                name: fields.color,
                editorTemplate: "ColorPickerField",
                displayName: "Text Color",
                defaultValue: "#fff",
                fieldType: "General",
            },
            {
                name: fields.topBannerTextFeild,
                displayName: "Rotate Banner Content",
                editorTemplate: "CodeSnippetField",
                defaultValue: "",
                fieldType: "General",
                tooltip: "You can add customized banner content.",
                placeholder: "text placeholder",
                isRequired: true,
            },
            {
                name: fields.interval,
                displayName: "Interval",
                editorTemplate: "IntegerField",
                defaultValue: 5000,
                fieldType: "General",
                tooltip: "Add slider interval (1000 = 1 sec)",
                placeholder: "Please enter slider interval",
            },
        ],
    },
};

export default widgetModule;